import cx from 'classnames'
import type { ComponentProps } from 'react'
import { Separator } from 'react-resizable-panels'

import { CollapsibleHandleButton } from './CollapsibleHandleButton'

type Props = {
  isOpen: boolean
  onToggle: () => void
} & ComponentProps<typeof Separator>

export const CollapsibleResizeHandle = ({
  isOpen,
  onToggle,
  ...handleProps
}: Props) =>
  isOpen ? (
    <Separator
      {...handleProps}
      className={cx(
        'relative overflow-visible dark:bg-slate-700 bg-slate-300 w-1',
        handleProps.className,
      )}
    >
      <CollapsibleHandleButton isOpen={isOpen} onClick={onToggle} />
    </Separator>
  ) : (
    <div className="relative overflow-visible">
      <CollapsibleHandleButton isOpen={isOpen} onClick={onToggle} />
    </div>
  )
